// Optionswerte numerisch sortieren + kompakt-CSS + Bild-Lightbox + Klarna-Logo
(function(){
 var l=document.createElement('link');l.rel='stylesheet';
 var tp=document.querySelector('link[href*="tp.css"]');
 l.href=(tp?tp.href.replace(/tp\.css.*$/,'tp-compact.css'):'');
 if(l.href)document.head.appendChild(l);
 function num(s){s=String(s).replace(',','.');var m=s.match(/[\d.]+/);return m?parseFloat(m[0]):0}
 document.querySelectorAll('.opt-vals[data-name]').forEach(function(w){
  var btns=[].slice.call(w.querySelectorAll('.opt-btn'));
  btns.sort(function(a,b){return num(a.getAttribute('data-val'))-num(b.getAttribute('data-val'))});
  btns.forEach(function(b){w.appendChild(b)});
 });

 // ---- Bestpreis-Garantie Badge oben rechts (nur Produktseiten) ----
 function bpBadge(small){
  var d=document.createElement('div');
  d.setAttribute('aria-label','Bestpreis-Garantie');
  d.style.cssText='position:absolute;top:12px;right:12px;z-index:5;width:'+(small?'70':'86')+'px;height:'+(small?'70':'86')+'px;border-radius:999px;background:#BF0C12;color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;text-align:center;box-shadow:0 4px 14px rgba(191,12,18,.35);border:2px solid #fff;transform:rotate(6deg);pointer-events:none';
  d.innerHTML='<span style="font-size:'+(small?'14':'18')+'px;line-height:1;font-weight:700">\u2713</span><span style="font-family:Poppins,sans-serif;font-weight:700;font-size:'+(small?'9.5':'11.5')+'px;line-height:1.15">Bestpreis-<br>Garantie</span>';
  return d;
 }
 var isM=window.matchMedia('(max-width:900px)').matches;
 if(location.pathname.indexOf('/products/')>-1){
  var g=document.getElementById('gal');
  if(g)g.appendChild(bpBadge(isM));
 }

 // ---- Klarna-Badge vor der Ratenzeile (überlebt Re-Renders via Observer) ----
 var kr=document.getElementById('klarna-rate');
 if(kr){
  var badge='<span class="klarna-ico" style="display:inline-flex;vertical-align:middle;margin-right:8px"><svg width="54" height="22" viewBox="0 0 54 22" role="img" aria-label="Klarna"><rect width="54" height="22" rx="4" fill="#FFB3C7"></rect><text x="27" y="15.5" text-anchor="middle" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="11.5" fill="#17120F">Klarna.</text></svg></span>';
  function inject(){
   if(kr.querySelector('.klarna-ico'))return;
   if(!/Klarna/.test(kr.textContent))return;
   kr.insertAdjacentHTML('afterbegin',badge);
  }
  new MutationObserver(inject).observe(kr,{childList:true});
  inject();
 }

 // ---- Lightbox: Produktbild in groß ----
 var gal=document.getElementById('gal'), main=document.getElementById('main-img');
 if(!gal||!main)return;
 var imgs=(gal.getAttribute('data-images')||'').split('|').filter(Boolean);
 if(!imgs.length)imgs=[main.src];
 main.style.cursor='zoom-in';
 var lb=null, lbImg=null, lbDots=[], idx=0;
 function build(){
  lb=document.createElement('div');
  lb.style.cssText='position:fixed;inset:0;background:rgba(20,21,23,.92);z-index:9999;display:flex;align-items:center;justify-content:center;flex-direction:column;padding:20px';
  lbImg=document.createElement('img');
  lbImg.style.cssText='max-width:96vw;max-height:82vh;object-fit:contain;border-radius:8px';
  var close=document.createElement('button');
  close.innerHTML='\u2715';
  close.setAttribute('aria-label','Schlie\u00dfen');
  close.style.cssText='position:absolute;top:16px;right:16px;width:42px;height:42px;border-radius:999px;border:none;background:rgba(255,255,255,.15);color:#fff;font-size:18px;cursor:pointer';
  close.addEventListener('click',hide);
  var dots=document.createElement('div');
  dots.style.cssText='display:flex;gap:8px;justify-content:center;margin-top:16px';
  imgs.forEach(function(_,j){
   var d=document.createElement('span');
   d.style.cssText='width:10px;height:10px;border-radius:999px;background:rgba(255,255,255,.35);cursor:pointer;transition:.15s';
   d.addEventListener('click',function(e){e.stopPropagation();show(j)});
   dots.appendChild(d);lbDots.push(d);
  });
  if(imgs.length<2)dots.style.display='none';
  lb.appendChild(lbImg);lb.appendChild(close);lb.appendChild(dots);
  lb.addEventListener('click',function(e){if(e.target===lb)hide()});
  var x0=null;
  lb.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
  lb.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)show(idx+(dx<0?1:-1));x0=null},{passive:true});
  document.addEventListener('keydown',function(e){
   if(!lb||lb.style.display==='none')return;
   if(e.key==='Escape')hide();
   if(e.key==='ArrowRight')show(idx+1);
   if(e.key==='ArrowLeft')show(idx-1);
  });
  document.body.appendChild(lb);
 }
 function show(i){
  idx=(i+imgs.length)%imgs.length;
  lbImg.src=imgs[idx];
  lbDots.forEach(function(d,j){d.style.background=j===idx?'#BF0C12':'rgba(255,255,255,.35)';d.style.transform=j===idx?'scale(1.3)':'none'});
 }
 function hide(){lb.style.display='none';document.body.style.overflow=''}
 main.addEventListener('click',function(){
  if(!lb)build();
  lb.style.display='flex';
  document.body.style.overflow='hidden';
  var cur=imgs.indexOf(main.src);
  show(cur>=0?cur:0);
 });
})();
